import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { FreeTrialStatusAlert } from "@src/components/MainApp/Alerts/FreeTrialStatusAlert";
import { MissingBillingAlert } from "@src/components/MainApp/Alerts/MissingBillingAlert";
import { useAgencyEmailAccess } from "@src/hooks/useAgencyEmailAccess";

export const SubscriptionInfoAlert = () => {
  const orgSummary = useGetOrganizationSummary();
  const { hasAgencyEmailAccess } = useAgencyEmailAccess();

  const missingBillings =
    orgSummary.data.org.stripeSubscriptionSummaries.filter((ss) => {
      return (
        ["active", "trialing", "pending", "incomplete"].includes(ss.status) &&
        !ss.customer.billing &&
        hasAgencyEmailAccess(ss, orgSummary.data.org.agencies.length > 0)
      );
    });

  if (missingBillings.length) {
    return <MissingBillingAlert missingBillings={missingBillings} />;
  } else {
    return <FreeTrialStatusAlert />;
  }
};
